import { SectionLabel, SplitLines } from "./Motion";
import { Star } from "./brand/Logo";

/** Oversized editorial page header used on inner pages. */
export const PageHero = ({ label, lines, sub, accentLine = -1, children, testid }) => (
  <section className="relative mx-auto max-w-[1440px] px-5 pb-16 pt-36 md:px-10 md:pb-24 md:pt-48" data-testid={testid}>
    <div className="pointer-events-none absolute right-0 top-28 hidden h-[560px] w-[560px] md:block" aria-hidden="true">
      <div className="absolute inset-0 bg-[radial-gradient(circle,rgba(183,148,246,0.18),transparent_60%)]" />
      <Star className="relative h-full w-full text-lav/[0.14]" cut />
    </div>
    <SectionLabel>{label}</SectionLabel>
    <h1 className="mt-8 font-display text-[15vw] font-extrabold uppercase leading-[0.84] text-ivory accent-safe accent-safe-loose md:text-[10vw] xl:text-[150px]">
      <SplitLines immediate lines={lines} lineClass={(i) => (i === accentLine ? "text-lav" : "")} />
    </h1>
    {sub && <p className="mt-10 max-w-xl text-base leading-relaxed text-mist md:text-lg">{sub}</p>}
    {children}
  </section>
);
